import print from '../transactions/overview/cells/print';
import printSight from './finsight-print';
// PRICING DATE
// INDUSTRY
// REGINO
// ISSUER
// CCY
// SIZE (M)
// UPSIZED
// TNR
// MTY
// RNK
// MO
// SP
// FI
// TYPE  "FX", "VAR", "FL
// BNCH	"Swaps", "G", "3mBBSW", "ASW", "ACGB", "3mEu", "OLO"
// SPRD
// CPN
// PRICE
const tableMapFinsight = (interestBasisMap, regionsMap, statusMap, sectorMap, industryMap, usSalesMap) => ([
    { header: 'DEAL_ID', printFn: (t) => t.transaction.id },
    { header: 'TRANCHE_ID', printFn: (t) => t.trancheIndex.toString() },
    { header: 'PRICING DATE', printFn: print.pricingDate },
    { header: 'REGION', printFn: print.regions(regionsMap) },
    { header: 'ISSUER', printFn: print.issuer },
    { header: 'CCY', printFn: print.currency },
    { header: 'SIZE (M)', printFn: print.amount },
    { header: 'UPSIZED', printFn: () => "" },
    { header: 'TENOR', printFn: print.tenor },
    { header: 'MTY', printFn: print.maturity },
    { header: 'RNK', printFn: r => print.documentationArray('statusOfNotes')(r)?.map(v => statusMap.get(v)).join(", ") },
    { header: 'MO', printFn: print.ratingIndividual('moodys', 'MOODYS') },
    { header: 'SP', printFn: print.ratingIndividual('sp', 'S_P') },
    { header: 'FI', printFn: print.ratingIndividual('fitch', 'FITCH') },
    { header: 'TYPE', printFn: print.interestBasis },
    { header: 'BNCH', printFn: print.benchmark },
    { header: 'SPRD', printFn: print.spread },
    { header: 'CPN', printFn: print.coupon },
    { header: 'PRICE', printFn: print.price },
    { header: 'industry', printFn: print.companySector(sectorMap, 'sector') },
    { header: 'subindustry', printFn: print.companySector(industryMap, 'industry') },
    { header: 'structuring_lead', printFn: print.structuringLead },
    { header: 'joint_lead', printFn: print.bookrunners },
    { header: 'parent', printFn: print.ultimateParent },
    { header: 'ticker', printFn: print.ticker },
    { header: 'dbrs', printFn: print.ratingIndividual('dbrs', 'DBRS') },
    { header: 'morningstar', printFn: print.ratingIndividual('morningstar', 'MORN_STAR') },
    { header: 'kroll', printFn: print.ratingIndividual('kroll', 'KBRA') },
    { header: 'euler_hermes', printFn: print.ratingIndividual('euler_hermes', 'EUL_HER') },
    { header: 'fedafin', printFn: print.ratingIndividual('fedafin', 'FEDAFIN') },
    { header: 'scope', printFn: print.ratingIndividual('scope', 'SCOPE') },
    { header: 'china_dagong', printFn: print.ratingIndividual('china_dagong', 'CH_DAG') },
    { header: 'china_pengyuan', printFn: print.ratingIndividual('china_pengyuan', 'CSPI') },
    { header: 'china_chengxin', printFn: print.ratingIndividual('china_chengxin', 'CCXAP') },
    { header: 'ram', printFn: print.ratingIndividual('ram', 'RAM') },
    { header: 'r_and_i', printFn: print.ratingIndividual('r_and_i', 'R_I') },
    { header: 'marc', printFn: print.ratingIndividual('marc', 'MARC') },
    { header: 'tris', printFn: print.ratingIndividual('tris', 'TRIS') },
    { header: 'initial_price_guidance', printFn: print.initialPriceThoughts },
    { header: 'guidance', printFn: print.guidance },
    { header: 'yield', printFn: print.yield },
    { header: 'expected_maturity_date', printFn: print.expectedMaturityDate },
    { header: 'first_pay_date', printFn: print.firstPayDate },
    { header: 'redemption', printFn: print.redemption },
    { header: 'new_issue_concession', printFn: print.newIssueConcession },
    { header: 'book_size_mm', printFn: print.book },
    { header: 'cusip', printFn: print.cusip },
    { header: 'cusip_regs', printFn: print.identifier('CUSIP', 'REGS') },
    { header: 'isin', printFn: print.isin },
    { header: 'registration', printFn: r => print.documentationArray('usSales')(r)?.map(v => usSalesMap.get(v)).join(", ") },
    { header: 're_open', printFn: print.tapText },
    { header: 'verified', printFn: print.verified },
    { header: 'min_denomination', printFn: print.minDenomination },
    { header: 'collateral', printFn: print.collateral },
]);
const tableMapFinsightNew = (interestBasisMap, regionsMap, statusMap, sectorMap, industryMap, usSalesMap) => ([
    { header: 'DEAL_ID', printFn: printSight.dealId },
    { header: 'Country', printFn: printSight.country },
    { header: 'CCY', printFn: printSight.currency },
    { header: 'Region 2', printFn: printSight.region2 },
    { header: 'Region 3', printFn: printSight.region3 },
    { header: 'Region 4', printFn: printSight.region4 },
    { header: 'Product', printFn: printSight.product },
    { header: 'Parent', printFn: printSight.parent },
    { header: 'Issuer 1', printFn: printSight.issuer1 },
    { header: 'Ticker 1', printFn: printSight.ticker1 },
    { header: 'Issuer 2', printFn: printSight.issuer2 },
    { header: 'Ticker 2', printFn: printSight.ticker2 },
    { header: 'Series', printFn: printSight.series },
    { header: 'Sector', printFn: printSight.sector(industryMap) },
    { header: 'Subsector', printFn: printSight.subSector(industryMap) },
    { header: 'Announced', printFn: printSight.announced },
    { header: 'Pricing', printFn: printSight.pricing },
    { header: 'Settlement', printFn: printSight.settlement },
    { header: 'Class', printFn: printSight.class },
    { header: 'Size (m)', printFn: printSight.size },
    { header: 'WAL', printFn: printSight.wal },
    { header: 'WAL ext', printFn: printSight.walExt },
    { header: 'Ranking', printFn: printSight.ranking(statusMap) },
    { header: 'Tenor', printFn: printSight.tenor },
    { header: 'Maturity Exp', printFn: printSight.maturityExp },
    { header: 'Maturity Legal', printFn: printSight.maturityLegal },
    { header: 'C/E', printFn: printSight.ce },
    { header: 'LTV', printFn: printSight.ltv },
    { header: 'Type', printFn: printSight.settlement },
    { header: 'Benchmark', printFn: printSight.benchmark },
    { header: 'IPT', printFn: printSight.ipt },
    { header: 'GDNC', printFn: printSight.gdnc },
    { header: 'SPRD', printFn: printSight.sprd },
    { header: 'CPN', printFn: printSight.cpn },
    { header: 'YLD', printFn: printSight.yld },
    { header: 'Price', printFn: printSight.price },
    { header: 'NIC', printFn: printSight.nic },
    { header: 'Book Size (m)', printFn: printSight.bookSize },
    { header: 'CUSIP', printFn: printSight.cusip },
    { header: 'ISIN', printFn: printSight.isins },
    { header: 'Registration', printFn: printSight.registration(usSalesMap) },
    { header: 'ERISA', printFn: printSight.erisa },
    { header: 'Retained', printFn: printSight.retained },
    { header: 'IO', printFn: printSight.io },
    { header: 'Upsized', printFn: printSight.upsized },
    { header: 'Verified', printFn: printSight.verified },
    { header: 'Moodys', printFn: printSight.rating('MOODYS') },
    { header: 'S&P', printFn: printSight.rating('S_P') },
    { header: 'Fitch', printFn: printSight.rating('FITCH') },
    { header: 'DBRS', printFn: printSight.rating('DBRS') },
    { header: 'Kroll', printFn: printSight.rating('KBRA') },
    { header: 'AM Best', printFn: printSight.rating('AM_BEST') },
    { header: 'MornStar', printFn: printSight.rating('MORN_STAR') },
    { header: 'Euler Hermes', printFn: printSight.rating('EUL_HER') },
    { header: 'Fedafin', printFn: printSight.rating('FEDAFIN') },
    { header: 'Scope', printFn: printSight.rating('SCOPE') },
    { header: 'China Dagong', printFn: printSight.rating('CH_DAG') },
    { header: 'China Lianha', printFn: printSight.rating('LIANHE') },
    { header: 'China Pengyuan', printFn: printSight.rating('CH_PEN') },
    { header: 'China Chengxin', printFn: printSight.rating('CCXAP') },
    { header: 'RAM', printFn: printSight.rating('RAM') },
    { header: 'JCR', printFn: printSight.rating('JCR') },
    { header: 'R&I', printFn: printSight.rating('R_I') },
    { header: 'Marc', printFn: printSight.rating('MARC') },
    { header: 'Tris', printFn: printSight.rating('TRIS') },
    { header: 'SL 1', printFn: printSight.sl(1) },
    { header: 'SL 2', printFn: printSight.sl(2) },
    { header: 'SL 3', printFn: printSight.sl(3) },
    { header: 'SL 4', printFn: printSight.sl(4) },
    { header: 'JB 1', printFn: printSight.jb(1) },
    { header: 'JB 2', printFn: printSight.jb(2) },
    { header: 'JB 3', printFn: printSight.jb(3) },
    { header: 'JB 4', printFn: printSight.jb(4) },
    { header: 'JB 5', printFn: printSight.jb(5) },
    { header: 'JB 6', printFn: printSight.jb(6) },
    { header: 'JB 7', printFn: printSight.jb(7) },
    { header: 'JB 8', printFn: printSight.jb(8) },
    { header: 'JB 9', printFn: printSight.jb(9) },
    { header: 'JB 10', printFn: printSight.jb(10) },
    { header: 'JB 11', printFn: printSight.jb(11) },
    { header: 'JB 12', printFn: printSight.jb(12) },
    { header: 'Collateral', printFn: printSight.collateral },
    { header: 'Guarantor(s)', printFn: printSight.guarantors },
    { header: 'Originator(s)', printFn: printSight.originators },
    { header: 'Risk Retention', printFn: printSight.riskRetention },
    { header: 'Use of Proceeds', printFn: printSight.useOfProceeds },
    { header: 'Volcker Compliance', printFn: printSight.volckerCompliance },
    { header: 'First Pay Date', printFn: printSight.firstPayDate },
    { header: 'Min. Denomination', printFn: printSight.minDenomination },
    { header: 'Redemption', printFn: printSight.redemption },
    { header: 'Cut-off Balance', printFn: printSight.cutOffBalance },
    { header: 'Expected Pricing Date', printFn: printSight.expPricingDate },
    { header: 'Expected Rating Date', printFn: printSight.expRatingDate },
    { header: 'Expected Settlement Date', printFn: printSight.expSettlementDate },
    { header: 'Pricing Speed', printFn: printSight.pricingSpeed },
    { header: '# of Loans', printFn: printSight.noOfLoans },
    { header: '# of Properties', printFn: printSight.noOfProperties },
    { header: 'Top 10 Loans %', printFn: printSight.top10Loans },
    { header: 'WA Cut-Off LTV', printFn: printSight.waCutOffLTV },
    { header: 'WA Maturity LTV', printFn: printSight.waMatLTV },
    { header: 'WA Rem. Amrt Term (Months)', printFn: printSight.waRemAmrtTerm },
    { header: 'WA Seasoning (Months)', printFn: printSight.waSeasoning },
    { header: 'WA Term to Maturity (Months)', printFn: printSight.waTermToMat },
    { header: 'WA U/W DSCR', printFn: printSight.waUWDSCR },
    { header: 'WA U/W Noi Debt Yield', printFn: printSight.waUWNoiDY },
    { header: 'Reinvestment Period (Yrs)', printFn: printSight.reinvPeriod },
    { header: 'Reinvestment Period End Date', printFn: printSight.reinvPeriodED },
    { header: 'Refinancing', printFn: printSight.refinancing },
    { header: 'Reset', printFn: printSight.reset },
    { header: 'WAL Test Period (Yrs)', printFn: printSight.walTestPeriod },
    { header: 'WAL Test Period End Date', printFn: printSight.walTestPeriodED },
    { header: 'Window Start', printFn: printSight.windowStart },
    { header: 'Window End', printFn: printSight.windowEnd },
    { header: 'Comments (Tranche)', printFn: printSight.comments },
    { header: 'ABS Maturity', printFn: printSight.absMaturity },
]);
const tableMapInterprice = (esgMap) => ([
    { header: 'DealId', printFn: (t) => t.transaction.id },
    { header: 'Issuer', printFn: print.issuer },
    { header: 'DealStatus', printFn: () => 'PRICED' },
    { header: 'BBGTicker', printFn: print.ticker },
    { header: 'TrancheId', printFn: (t) => t.trancheIndex.toString() },
    { header: 'Coupon', printFn: print.coupon },
    // { header: 'CouponType', printFn: print.interestBasis },
    { header: 'Currency', printFn: print.currency },
    { header: 'ESG', printFn: print.documentation('esg') },
    { header: 'Guidance', printFn: print.guidance },
    { header: 'IPT', printFn: print.initialPriceThoughts },
    { header: 'Maturity', printFn: print.maturity },
    {
        header: 'Oversubscription',
        printFn: (value) => {
            const os = print.oversubscription(value);
            if (os === undefined || typeof os === 'string') {
                return os;
            }
            const options = { maximumFractionDigits: 1 };
            return Intl.NumberFormat((new Intl.NumberFormat()).resolvedOptions().locale, options).format(os.value);
        },
    },
    { header: 'Pricing', printFn: print.pricing },
    { header: 'Rating', printFn: print.ratings },
    { header: 'PricingDate', printFn: print.pricingDate },
    { header: 'Settlement', printFn: print.settlementDate },
    { header: 'Size', printFn: print.amount },
    { header: 'Spread', printFn: print.spread },
    { header: 'Yield', printFn: print.yield },
    {
        header: 'Tap',
        printFn: (value) => {
            const t = print.tap(value);
            return t === true ? "TRUE" : undefined;
        },
    },
]);
export const interpriceColumns = tableMapInterprice(new Map()).map((m) => m.header);
const transformDataForInterprice = (data, esgMap) => {
    const all = tableMapInterprice(esgMap);
    const allArrays = [];
    const headers = all.map((i) => i.header);
    allArrays.push(headers);
    data.forEach((t) => {
        const trancheRow = all.map((i) => {
            const value = i.printFn(t);
            if (typeof value === 'string') {
                if (value.includes(',') || value.includes('"') || value.includes('\n')) {
                    const newValue = value.replaceAll('"', '""');
                    return `"${newValue}"`;
                }
                return value;
            }
            if (Array.isArray(value)) {
                return value.map(v => {
                    if (typeof v === 'object') {
                        if (typeof v.value === 'number') {
                            return v.value.toString();
                        }
                    }
                }).join(" ");
            }
            else {
                if (typeof value === 'object') {
                    if (value.value instanceof Date) {
                        return value.value.toISOString().substring(0, 10);
                    }
                    else {
                        if (typeof value.value === 'number') {
                            return value.value.toString();
                        }
                    }
                }
                return '';
            }
        });
        allArrays.push(trancheRow);
    });
    return allArrays;
};
export default transformDataForInterprice;
export const transformDataForFinsight = (data, interestBasisMap, regionMap, statusMap, industryMap, sectorMap, usSalesMap) => {
    const all = tableMapFinsightNew(interestBasisMap, regionMap, statusMap, sectorMap, industryMap, usSalesMap);
    const allArrays = [];
    const headers = all.map((i) => i.header);
    allArrays.push(headers);
    data.forEach((t) => {
        const trancheRow = all.map((i) => {
            const value = i.printFn(t);
            if (typeof value === 'string') {
                if (value.includes(',') || value.includes('"') || value.includes('\n')) {
                    const newValue = value.replaceAll('"', '""');
                    return `"${newValue}"`;
                }
                return value;
            }
            if (Array.isArray(value)) {
                return value.map(v => {
                    if (typeof v === 'object') {
                        if (typeof v.value === 'number') {
                            return v.value.toString();
                        }
                    }
                }).join(" ");
            }
            else if (typeof value === 'object' && value !== null) {
                if (value.value instanceof Date) {
                    return value.value.toISOString().substring(0, 10);
                }
                else {
                    if (typeof value.value === 'number') {
                        return value.value.toString();
                    }
                }
            }
            return '';
        });
        allArrays.push(trancheRow);
    });
    return allArrays;
};
